import { DiffOutlined } from "@ant-design/icons";
import { ResourceProps } from "@refinedev/core";

export const mappingResource: ResourceProps = {
  name: "mapping",
  meta: {
    icon: <DiffOutlined />,
    label: "Маппинг",
  },
};

export const pariResource: ResourceProps = {
  name: "pari",
  list: "/mapping/pari",
  meta: {
    parent: "mapping",
    label: "Лига PARI",
  },
};

export const leonAResource: ResourceProps = {
  name: "leon_a",
  list: "/mapping/leon_a",
  meta: {
    parent: "mapping",
    label: "LEON A",
  },
};

export const leonBResource: ResourceProps = {
  name: "leon_b",
  list: "/mapping/leon_b",
  meta: {
    parent: "mapping",
    label: "LEON B",
  },
};

export const rusStatResource: ResourceProps = {
  name: "russtat",
  list: "/mapping/russtat",
  meta: {
    parent: "mapping",
    label: "Рустат",
  },
};

export const rusStatClubsResource: ResourceProps = {
  name: "russtat-clubs",
  list: "/mapping/russtat/clubs/:fnlLeagueId/:fnlSeasonId",
  meta: {
    parent: "russtat",
    hide: true,
  },
};

export const rusStatPlayersResource: ResourceProps = {
  name: "russtat-players",
  list: "/mapping/russtat/clubs/:fnlLeagueId/:fnlSeasonId/:fnlTeamId",
  meta: {
    parent: "russtat",
    hide: true,
  },
};
